export default __webpack_public_path__ + "static/media/launchpad-icon.047b645a.svg";